export const API_URL = 'https://edutech.expertus.com.ua/data';
